import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../api/api";

export default function TiposLocalizacao() {
  const [tipos, setTipos] = useState([]);
  const [novoNome, setNovoNome] = useState("");
  const [msg, setMsg] = useState("");

  // ============================
  // 🔄 Carregar tipos de localização
  // ============================
  async function load() {
    try {
      const data = await apiGet("/tipos-localizacao/");
      setTipos(data);
    } catch {
      setMsg("Erro ao carregar tipos de localização");
    }
  }

  useEffect(() => {
    load();
  }, []);

  // ============================
  // ➕ Criar tipo de localização
  // ============================
  async function criarTipoLocalizacao() {
    if (!novoNome.trim()) {
      setMsg("O nome não pode estar vazio");
      return;
    }

    try {
      await apiPost("/tipos-localizacao/", { nome: novoNome });
      setNovoNome("");
      setMsg("");
      load();
    } catch {
      setMsg("Erro: tipo já existe ou sem permissões");
    }
  }

  // ============================
  // 🗑 Apagar tipo de localização
  // ============================
  async function apagarTipoLocalizacao(id) {
    if (!window.confirm("Tem a certeza que deseja apagar?")) return;

    await fetch(`/api/tipos-localizacao/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
    });

    load();
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Gestão de Tipos de Localização</h2>

      {msg && <p style={{ color: "red" }}>{msg}</p>}

      {/* Criar tipo */}
      <div
        style={{
          marginTop: 20,
          padding: 15,
          background: "#f7f7f7",
          borderRadius: 8,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <h3>Novo Tipo de Localização</h3>

        <input
          placeholder="Nome do tipo"
          value={novoNome}
          onChange={(e) => setNovoNome(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />

        <button
          onClick={criarTipoLocalizacao}
          style={{
            marginTop: 10,
            padding: "8px 15px",
            background: "#2e7d32",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Criar
        </button>
      </div>

      {/* Listagem */}
      <h3 style={{ marginTop: 30 }}>Tipos de localização existentes</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: 10 }}>ID</th>
            <th style={{ padding: 10 }}>Nome</th>
            <th style={{ padding: 10 }}>Ações</th>
          </tr>
        </thead>

        <tbody>
          {tipos.map((tp) => (
            <tr key={tp.id} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: 10 }}>{tp.id}</td>
              <td style={{ padding: 10 }}>{tp.nome}</td>

              <td style={{ padding: 10 }}>
                <button
                  onClick={() => apagarTipoLocalizacao(tp.id)}
                  style={{
                    padding: "6px 12px",
                    background: "#c62828",
                    color: "white",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Apagar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
